import type { IContainer, IPhoto, IPhotoCrop } from '../../common/types/index.js';

export function getCenterCrop(photo: IPhoto, container: IContainer): IPhotoCrop {
    const containerAspectRatio = container.width / container.height;
    const photoAspectRatio = photo.width / photo.height;

    const crop: IPhotoCrop = {
        x: 0,
        y: 0,
        width: photo.width,
        height: photo.height,
        rank: 0,
    };

    if (photoAspectRatio > containerAspectRatio) {
        crop.width = crop.height * containerAspectRatio;
        crop.x = Math.round((photo.width - crop.width) / 2);
    } else if (photoAspectRatio < containerAspectRatio) {
        crop.height = crop.width / containerAspectRatio;
        crop.y = Math.max(0, Math.round((photo.height / 3) - (crop.height / 2)));
    }

    return crop;
}
